document.querySelectorAll('.language-nav').forEach((wrap) => {
  const languageButton = wrap.querySelector('.language-nav__li__a:first-child');
  const toggleLanguage = (event) => {
    wrap.classList.toggle('language-nav--expanded');
    event.preventDefault();
  };
  languageButton.addEventListener('click', toggleLanguage);
});
